export default "/fonts/icon-font.woff?d7c1f5394583287397484f85dbec2db1";